export default __webpack_public_path__ + "static/media/galleryBg.f9d098d9.png";